import React, { useEffect, useState } from "react";
import useClientConfig from "../../../../../config/careers/clientConfig";
import { useDispatch, useSelector } from "react-redux";
import { getJobList } from "../../../../../redux/slices/careersSlices.reducer";


function ManpowerBanner() {
    const {clientAssetsLink, clientConfig} = useClientConfig();
    const dispatch = useDispatch();

    const filterJobs = (jobType: string) => {
        const apiParams: any = {};
        const obj: any = {};

        apiParams["searchKeyword"] = jobType;
        obj["url"] = clientConfig?.data?.data?.clientSettings?.clientId;
        obj["params"] = apiParams;
        dispatch<any>(getJobList(obj));

        //scroll down to job list
        setTimeout(() => {
            const element = document.getElementsByClassName("mob-job-search-parent")[0];
            if(element){
                const yOffset = -100; 
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: "smooth"});
            }
        }, 250);
    };

    return (
        <>
            <div className="banner-manpower index_banner">
                <div className="banner-img">
                    {/* <img src={process.env.PUBLIC_URL + menuSettings.bannerImg1} /> */}
                </div>
                <div className="ban_info">
                    <h1>釋放人才的發展潛能
                        <span className="txt_up">Unleash the Power of Human Potential</span></h1>
                </div>
            </div>
            <div className="hsbc-job-banner container">
                <div className="well center" onClick={() => filterJobs("hsbc")}>
                    <div className="highlight">Featured Company - HSBC jobs</div>
                    <br />
                    <ul className="unstyled featuring animated fadeIn">
                        <img src={ clientAssetsLink + "/manpower-hsbc.png"} />
                    </ul>
                    <br />
                </div>
            </div>
        </>
    );
}

export default ManpowerBanner;